import { ShapeConfig } from '../../types';
import {
  COMBO_TYPES,
  EDGE_TYPES,
  NODE_TYPES,
  comboTypeConfigs,
  edgeTypeConfigs,
  nodeTypeConfigs,
} from '../../shapes';

// These need to come before the others because they are being inherited from
export const baseNodeConfigs = [
  nodeTypeConfigs[NODE_TYPES.BASE],
  nodeTypeConfigs[NODE_TYPES.BASE_WITH_FOOTER],
  nodeTypeConfigs[NODE_TYPES.BASE_WITH_NESTED_NODES],
  nodeTypeConfigs[NODE_TYPES.DELAY_BASE],
  nodeTypeConfigs[NODE_TYPES.CONTACT_ACTION_BASE],
  nodeTypeConfigs[NODE_TYPES.MISC_BASE],
  nodeTypeConfigs[NODE_TYPES.MODIFYFLOW_BASE],
  nodeTypeConfigs[NODE_TYPES.SEND_ACTION_BASE],
];

export const defaultNodeConfigs: ShapeConfig[] = [
  ...baseNodeConfigs,
  nodeTypeConfigs[NODE_TYPES.AB_SPLIT],
  nodeTypeConfigs[NODE_TYPES.ADD_CONTACT],
  nodeTypeConfigs[NODE_TYPES.ADD_USER_TO_FB],
  nodeTypeConfigs[NODE_TYPES.ATTRIBUTE_SPLIT],
  nodeTypeConfigs[NODE_TYPES.CALL_WEBHOOK],
  nodeTypeConfigs[NODE_TYPES.CHANGE_CONTACT_FIELD],
  nodeTypeConfigs[NODE_TYPES.CHANNEL_OPT],
  nodeTypeConfigs[NODE_TYPES.DELAY],
  nodeTypeConfigs[NODE_TYPES.FIELDS_MATCH],
  nodeTypeConfigs[NODE_TYPES.HOLD],
  nodeTypeConfigs[NODE_TYPES.HOLD_UNTIL_REPLY],
  nodeTypeConfigs[NODE_TYPES.MODIFY_CHANNEL_SUBSCRIPTION],
  nodeTypeConfigs[NODE_TYPES.MODIFY_MESSAGE_TYPE],
  nodeTypeConfigs[NODE_TYPES.NOTE],
  nodeTypeConfigs[NODE_TYPES.REMOVE_CONTACT],
  nodeTypeConfigs[NODE_TYPES.REMOVE_USER_FROM_FB],
  nodeTypeConfigs[NODE_TYPES.SEND_EMAIL],
  nodeTypeConfigs[NODE_TYPES.SEND_EMBEDDED],
  nodeTypeConfigs[NODE_TYPES.SEND_IN_APP],
  nodeTypeConfigs[NODE_TYPES.SEND_PUSH],
  nodeTypeConfigs[NODE_TYPES.SEND_SMS],
  nodeTypeConfigs[NODE_TYPES.SEND_WEB_PUSH],
  nodeTypeConfigs[NODE_TYPES.SEND_WHATSAPP],
  nodeTypeConfigs[NODE_TYPES.START],
  nodeTypeConfigs[NODE_TYPES.TILESET],
  nodeTypeConfigs[NODE_TYPES.TRIGGER_WORKFLOW],
  nodeTypeConfigs[NODE_TYPES.UPDATE_CONTACT_WEBHOOK],
];

export const defaultEdgeConfigs: ShapeConfig[] = [edgeTypeConfigs[EDGE_TYPES.DEFAULT]];

export const defaultComboConfigs: ShapeConfig[] = [comboTypeConfigs[COMBO_TYPES.DEFAULT]];

export const FLOWCHART_TEST_ID = 'flowchart';

export const GRID_IMG =
  'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgwIiBoZWlnaHQ9IjI4NCIgdmlld0JveD0iMCAwIDI4MCAyODQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cmVjdCB3aWR0aD0iMjgwIiBoZWlnaHQ9IjI4NCIgZmlsbD0iI0Y1RjRGNCIvPgo8bGluZSB4MT0iMTM3LjUiIHkxPSIyLjEyMjc4ZS0wOCIgeDI9IjEzNy41IiB5Mj0iNzEwIiBzdHJva2U9IiNFMERFREYiIHN0cm9rZS1kYXNoYXJyYXk9IjIgMiIvPgo8bGluZSB4MT0iMjc5LjUiIHkxPSIyLjEyMjc4ZS0wOCIgeDI9IjI3OS41IiB5Mj0iNzEwIiBzdHJva2U9IiNFMERFREYiIHN0cm9rZS1kYXNoYXJyYXk9IjIgMiIvPgo8bGluZSB4MT0iMTI4MCIgeTE9IjAuNSIgeDI9Ii00LjM3MTE1ZS0wOCIgeTI9IjAuNDk5ODg4IiBzdHJva2U9IiNFMERFREYiIHN0cm9rZS1kYXNoYXJyYXk9IjIgMiIvPgo8bGluZSB4MT0iMTI4MCIgeTE9IjE0Mi41IiB4Mj0iLTQuMzcxMTVlLTA4IiB5Mj0iMTQyLjUiIHN0cm9rZT0iI0UwREVERiIgc3Ryb2tlLWRhc2hhcnJheT0iMiAyIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDAiPgo8cmVjdCB3aWR0aD0iMjgwIiBoZWlnaHQ9IjI4NCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K)';
